export const MOTION_FRAME_CAP=.035;
export const EVENT_FRAME_CAP=.25;
export const EVENT_SUBSTEP_CAP=.1;

export function frameTiming(rawDt){
 const raw=Number.isFinite(rawDt)&&rawDt>0?rawDt:0;
 const motionDt=Math.min(raw,MOTION_FRAME_CAP);
 const eventDt=Math.min(raw,EVENT_FRAME_CAP);
 const eventSteps=Math.max(1,Math.ceil(eventDt/EVENT_SUBSTEP_CAP));
 return {rawDt:raw,motionDt,eventDt,eventSteps,eventStepDt:eventDt/eventSteps,droppedMotionTime:Math.max(0,raw-motionDt),droppedEventTime:Math.max(0,raw-eventDt)};
}
